import React from 'react'

export default () => <div>
  <p>No checklists added for this category yet. Check back here soon.</p>
</div>


// WEBPACK FOOTER //
// ./src/components/fallback.js